module.exports = __webpack_public_path__ + "img/info.6128af1f.svg";